module.exports = __webpack_public_path__ + "static/media/circle-declined.eb5ddd4e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/circle-declined.svg
// module id = 2598
// module chunks = 1